import { Routes } from '@angular/router';

import { AuthGuard } from './auth.guard';

import { AuthComponent } from './layouts/auth/auth.component';
import { NoAuthComponent } from './layouts/no-auth/no-auth.component';
import { SigninComponent } from './signin/signin.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

export const AppRoutes: Routes = [{
  path: '',
  redirectTo: 'dashboard',
  pathMatch: 'full',
}, {
    path: '',
    component: AuthComponent,
    canActivate: [AuthGuard],
    children: [{
      path: '',
      loadChildren: './dashboard/dashboard.module#DashboardModule'
    }, {
        path: 'map',
        loadChildren: './map/map.module#MapModule'
      }, {
        path: 'contributions',
        loadChildren: './contributions/contributions.module#ContributionsModule'
      }]
  }, {
    path: '',
    component: NoAuthComponent,
    children: [
      {
        path: 'signin',
        component: SigninComponent
      }
    ]
  },
  { path: 'not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: '/not-found' }
];



// WEBPACK FOOTER //
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/app/app.routing.ts